<template>
  <el-dialog
    title="用户留言"
    :visible.sync="visible"
    :width="dialogWidth"
    append-to-body
    destroy-on-close
    custom-class="user-message-dialog-wrap"
    @closed="onClosed"
  >
    <div class="dialog-inner" v-loading="pageLoading">
      <div class="message-compose">
        <div class="compose-label">发表留言</div>
        <el-input
          v-model="draftContent"
          type="textarea"
          :rows="4"
          maxlength="2000"
          show-word-limit
          placeholder="请输入您的意见或建议（最多 2000 字）"
          class="compose-textarea"
        />
        <el-button
          type="primary"
          class="compose-submit"
          size="small"
          :loading="submitLoading"
          @click="submitMessage"
        >
          提交留言
        </el-button>
      </div>

      <div class="message-list-head">
        <span class="list-title">我的留言</span>
      </div>

      <div class="table-wrap" v-loading="listLoading">
        <el-table
          :data="tableData"
          stripe
          border
          size="small"
          empty-text="暂无留言"
          class="message-table"
          max-height="320"
        >
          <el-table-column
            prop="content"
            label="留言内容"
            min-width="160"
            show-overflow-tooltip
          />
          <el-table-column
            prop="createTime"
            label="提交时间"
            width="158"
            align="center"
          />
          <el-table-column label="操作" width="72" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="del-btn"
                @click="onDelete(scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="total > 0"
          class="message-pagination"
          background
          small
          layout="total, prev, pager, next"
          :current-page.sync="pageNo"
          :page-size.sync="pageSize"
          :total="total"
          @current-change="fetchList"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  sysUserMessageList,
  sysUserMessageAdd,
  sysUserMessageDelete,
} from "@/servers/api";
import { Message, MessageBox } from "element-ui";

export default {
  name: "UserMessageDialog",
  data() {
    return {
      visible: false,
      draftContent: "",
      tableData: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      pageLoading: false,
      listLoading: false,
      submitLoading: false,
    };
  },
  computed: {
    dialogWidth() {
      return typeof window !== "undefined" && window.innerWidth < 576
        ? "94%"
        : "720px";
    },
  },
  methods: {
    open() {
      this.visible = true;
      this.draftContent = "";
      this.pageNo = 1;
      this.$nextTick(() => this.fetchList());
    },
    onClosed() {
      this.tableData = [];
      this.total = 0;
    },
    fetchList() {
      if (!this.visible) {
        return;
      }
      this.listLoading = true;
      sysUserMessageList({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      })
        .then((res) => {
          this.listLoading = false;
          if (res.code !== 200) {
            return;
          }
          const page = res.result || {};
          this.tableData = page.records || [];
          this.total = page.total != null ? page.total : 0;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    submitMessage() {
      const text = (this.draftContent || "").trim();
      if (!text) {
        Message.warning("请输入留言内容");
        return;
      }
      this.submitLoading = true;
      sysUserMessageAdd({ content: text })
        .then((res) => {
          this.submitLoading = false;
          if (res.code === 200) {
            Message.success(res.message || "提交成功");
            this.draftContent = "";
            this.pageNo = 1;
            this.fetchList();
          }
        })
        .catch(() => {
          this.submitLoading = false;
        });
    },
    onDelete(row) {
      if (!row || row.id == null) {
        return;
      }
      MessageBox.confirm("确定删除该条留言吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.pageLoading = true;
          sysUserMessageDelete(row.id)
            .then((res) => {
              this.pageLoading = false;
              if (res.code === 200) {
                Message.success(res.message || "删除成功");
                if (this.tableData.length <= 1 && this.pageNo > 1) {
                  this.pageNo -= 1;
                }
                this.fetchList();
              }
            })
            .catch(() => {
              this.pageLoading = false;
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-inner {
  text-align: left;
  padding: 0 4px 8px;
}

.message-compose {
  .compose-label {
    font-size: 15px;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
  }

  ::v-deep .compose-textarea .el-textarea__inner {
    font-size: 14px;
    line-height: 1.5;
    color: rgba(0, 0, 0, 0.75);
  }

  .compose-submit {
    margin-top: 12px;
    background-color: $mainColor;
    border-color: $mainColor;

    &:hover,
    &:focus {
      background-color: $mainColor;
      border-color: $mainColor;
    }
  }
}

.message-list-head {
  margin: 20px 0 10px;
  padding-top: 12px;
  border-top: 1px dashed #dcdcdc;

  .list-title {
    font-size: 16px;
    font-weight: 700;
    color: #333;
  }
}

.table-wrap {
  min-height: 80px;
}

::v-deep .message-table {
  width: 100%;

  th {
    background: #f5f7fa;
    color: #333;
    font-weight: 600;
  }

  .del-btn {
    color: $mainColor;
    padding: 0;
  }

  .del-btn:hover {
    color: $mainColor;
  }
}

.message-pagination {
  margin-top: 12px;
  text-align: right;
}
</style>

<style lang="scss">
.user-message-dialog-wrap {
  .el-dialog__header {
    padding: 16px 20px 12px;
    border-bottom: 1px solid #ebeef5;
  }

  .el-dialog__title {
    font-size: 18px;
    font-weight: 700;
    color: #00a0e9;
  }

  .el-dialog__body {
    padding: 18px 20px 22px;
    max-height: calc(100vh - 140px);
    overflow-y: auto;
  }
}
</style>
